<template>
  <div class="xilie_pdt" @click="handleClick">
    <div class="list-show-img">
      <img
          :src="product.isHovered ? product.hoverImage : product.defaultImage"
          width="300"
          @mouseenter="handleMouseEnter"
          @mouseout="handleMouseLeave"
      >
    </div>
    <div class="pdt_name">
      <h4>{{ product.name }}</h4>
    </div>
    <div>
      <el-button type="success" plain @click.stop="handleClick">{{ $t("lookNow") }}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductCard",
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleMouseEnter() {
      this.$emit('mouseenter', this.product.id);
    },
    handleMouseLeave() {
      this.$emit('mouseleave', this.product.id);
    },
    handleClick() {
      this.$emit('click', this.product.id);
    }
  }
}
</script>

<style scoped>
/* 可以复用原组件中的样式，或根据需要调整 */
.xilie_pdt {
  padding: 20px;
  cursor: pointer;
}

.xilie_pdt:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.list-show-img {
  min-height: 200px;
  display: grid;
  place-items: center;
}

.list-show-img img {
  object-fit: cover;
}
</style>
